export var GroupVariants = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
//# sourceMappingURL=Group.utils.js.map